import { Rule } from '../models/Product';
import { checkGenericRulesFront } from '../utils/catalogRules';

export type genericRuleCatalog = {
  rule: string;
  action: string;
  value: string;
};

export const useGenericRulesCatalog = () => {
  function getGenericRuleCatalog(rules: Rule[], ruleCondition: string) {
    const genericRulesCatalog = checkGenericRulesFront(rules);
    if (genericRulesCatalog?.value) {
      const ruleListCatalog = JSON.parse(genericRulesCatalog.value) as genericRuleCatalog[];
      return ruleListCatalog.find(catalogRule => catalogRule.rule === ruleCondition);
    }
  }

  const hasGenericRuleCatalog = (ruleCondition: string, rules?: Rule[]) => {
    if (rules) return getGenericRuleCatalog(rules, ruleCondition);
  };

  function validateGenericRules(ruleCatalog: genericRuleCatalog, valueComparator: string) {
    switch (ruleCatalog.rule) {
      case 'gender':
        if (ruleCatalog.action === 'instrict') if (valueComparator === ruleCatalog.value) return true;

        return false;
      default:
        return false;
    }
  }

  return { getGenericRuleCatalog, validateGenericRules, hasGenericRuleCatalog };
};
